import {Order} from "./Order";
import {CartSection} from "./Sections/Cart";
import {ProductConfigSection} from "./Sections/ProductConfig";
import {Overview} from "./Overview";
import {NavCartButton} from "./NavCartButton";
import {formatNumber} from "../../helpers/format-number";

export class ProductItem {
  constructor(configSection, pageInfos, formDataObject, uuid = false) {
    const {count, heightMax, height, widthMax, width} = formDataObject;

    this.configSection = configSection;
    this.uuid = uuid ? `${uuid}` : `${Date.now()}`;
    this.pageInfos = pageInfos;
    this.formDataObject = formDataObject;
    this.priceData = this.calcProductPriceData(configSection.id, formDataObject);
  }

  static _getPageInfosByTemplate(template) {
    return ProductConfigSection.pageInfos.find(pageInfo => pageInfo.productId === template);
  }

  static _findTablePrice(priceTable, heightValue, widthValue) {
    const PRICE_TABLE_ROW = priceTable.find(item => `${item.height}` === `${heightValue}`);
    return PRICE_TABLE_ROW ? PRICE_TABLE_ROW[`width_${widthValue}`] : false
  }

  static _calcProductPrice(formDataObject, templateName) {
    const PAGE_INFO = ProductItem._getPageInfosByTemplate(templateName)
    const PRICE_TABLE = PAGE_INFO.priceTable;

    const COUNT_DATA = parseInt(formDataObject.count) > 0 ? parseInt(formDataObject.count) : 1;

    const HEIGHT_DATA = formDataObject.height;
    const HAS_MAX_HEIGHT = HEIGHT_DATA.includes('_max');
    const HEIGHT_VALUE = parseInt(HEIGHT_DATA.replace('_max', ''));
    const MAX_HEIGHT_DATA = parseInt(formDataObject.heightMax);
    const MAX_HEIGHT_VALUE = HAS_MAX_HEIGHT && (MAX_HEIGHT_DATA > HEIGHT_VALUE) ? MAX_HEIGHT_DATA : HEIGHT_VALUE + 1;

    const WIDTH_DATA = formDataObject.width;
    const HAS_MAX_WIDTH = WIDTH_DATA.includes('_max');
    const WIDTH_VALUE = parseInt(WIDTH_DATA.replace('_max', ''));
    const MAX_WIDTH_DATA = parseInt(formDataObject.widthMax);
    const MAX_WIDTH_VALUE = HAS_MAX_WIDTH && (MAX_WIDTH_DATA > WIDTH_VALUE) ? MAX_WIDTH_DATA : WIDTH_VALUE + 1;

    const HAS_STRIPS = !!formDataObject.strips;
    const SURCHARGE_STRIPS_PERCENT = PAGE_INFO.surchargeStripsPercent;
    let stripsSurchargeTotal = 0;

    const HAS_DOUBLE = !!formDataObject.double;
    const SURCHARGE_DOUBLE_PERCENT = PAGE_INFO.surchargeDoublePercent;
    let doubleSurchargeTotal = 0;

    const HAS_LUXAFLEX = !!formDataObject.luxaflex;
    const SURCHARGE_LUXAFLEX_PERCENT = PAGE_INFO.surchargeLuxaflexPercent;
    let luxaflexSurchargeTotal = 0;

    const HAS_ELECTRO = !!formDataObject.electro;
    const SURCHARGE_ELECTRO_PERCENT = PAGE_INFO.surchargeElectroPercent;
    let electroSurchargeTotal = 0;


    let productPrice = parseFloat(ProductItem._findTablePrice(PRICE_TABLE, HEIGHT_VALUE, WIDTH_VALUE));
    let mainPrice = productPrice;

    if (HAS_MAX_HEIGHT) {
      const HEIGHT_SURCHARGE_DATA = PAGE_INFO.heightSurchargeTable[0] || false;
      const HEIGHT_SURCHARGE_VALUE = HEIGHT_SURCHARGE_DATA ? HEIGHT_SURCHARGE_DATA[`height_${WIDTH_VALUE}`] : 0;

      let calculatedRest = 1
      if (parseFloat(MAX_HEIGHT_VALUE) >= parseFloat(HEIGHT_VALUE)) {
        calculatedRest = Math.ceil(MAX_HEIGHT_VALUE - parseFloat(HEIGHT_VALUE));
      }

      const HEIGHT_SURCHARGE_QUANTITY = Math.ceil(calculatedRest / 50);
      const HEIGHT_SURCHARGE_TOTAL = HEIGHT_SURCHARGE_QUANTITY * HEIGHT_SURCHARGE_VALUE;

      mainPrice += HEIGHT_SURCHARGE_TOTAL;
      productPrice += HEIGHT_SURCHARGE_TOTAL;
    }

    if (HAS_MAX_WIDTH) {
      const WIDTH_SURCHARGE_DATA = PAGE_INFO.widthSurchargeTable[0] || false;
      const WIDTH_SURCHARGE_VALUE = WIDTH_SURCHARGE_DATA ? WIDTH_SURCHARGE_DATA[`width_${HEIGHT_VALUE}`] : 0;

      let calculatedRest = 1
      if (parseFloat(MAX_WIDTH_VALUE) >= parseFloat(WIDTH_VALUE)) {
        calculatedRest = Math.ceil(MAX_WIDTH_VALUE - parseFloat(WIDTH_VALUE));
      }

      const WIDTH_SURCHARGE_QUANTITY = Math.ceil(calculatedRest / 50);
      const WIDTH_SURCHARGE_TOTAL = WIDTH_SURCHARGE_QUANTITY * WIDTH_SURCHARGE_VALUE;

      mainPrice += WIDTH_SURCHARGE_TOTAL;
      productPrice += WIDTH_SURCHARGE_TOTAL;
    }

    if (HAS_STRIPS) {
      stripsSurchargeTotal = (parseFloat(SURCHARGE_STRIPS_PERCENT) * productPrice) * 0.01;
      mainPrice += stripsSurchargeTotal;
    }

    if (HAS_DOUBLE) {
      doubleSurchargeTotal = (parseFloat(SURCHARGE_DOUBLE_PERCENT) * productPrice) * 0.01;
      mainPrice += doubleSurchargeTotal;
    }

    if (HAS_LUXAFLEX) {
      luxaflexSurchargeTotal = (parseFloat(SURCHARGE_LUXAFLEX_PERCENT) * productPrice) * 0.01;
      mainPrice += luxaflexSurchargeTotal;
    }

    if (HAS_ELECTRO) {
      electroSurchargeTotal = (parseFloat(SURCHARGE_ELECTRO_PERCENT) * productPrice) * 0.01;
      mainPrice += electroSurchargeTotal;
    }

    const PRICE_TOTAL = mainPrice * COUNT_DATA;

    return {
      quantity: COUNT_DATA,

      priceArticle: productPrice,
      priceTotal: PRICE_TOTAL,

      productHeight: {
        unit: 'cm',
        value: HAS_MAX_HEIGHT ? MAX_HEIGHT_VALUE : HEIGHT_VALUE,
        text: HAS_MAX_HEIGHT ? `${MAX_HEIGHT_VALUE} cm` : `bis ${HEIGHT_VALUE} cm`
      },

      productWidth: {
        unit: 'cm',
        value: HAS_MAX_WIDTH ? MAX_WIDTH_VALUE : WIDTH_VALUE,
        text: HAS_MAX_WIDTH ? `${MAX_WIDTH_VALUE} cm` : `bis ${WIDTH_VALUE} cm`
      },

      hasMaxHeight: HAS_MAX_HEIGHT,
      maxHeightValue: MAX_HEIGHT_VALUE,

      hasMaxWidth: HAS_MAX_WIDTH,
      maxWidthValue: MAX_WIDTH_VALUE,

      hasStrips: HAS_STRIPS,
      strips: {
        percentValue: SURCHARGE_STRIPS_PERCENT,
        surchargeTotal: parseFloat(stripsSurchargeTotal) || 0,
      },

      hasDouble: HAS_DOUBLE,
      double: {
        percentValue: SURCHARGE_STRIPS_PERCENT,
        surchargeTotal: parseFloat(doubleSurchargeTotal) || 0,
      },

      hasLuxaflex: HAS_LUXAFLEX,
      luxaflex: {
        percentValue: SURCHARGE_LUXAFLEX_PERCENT,
        surchargeTotal: parseFloat(luxaflexSurchargeTotal) || 0,
      },

      hasElectro: HAS_ELECTRO,
      electro: {
        percentValue: SURCHARGE_ELECTRO_PERCENT,
        surchargeTotal: parseFloat(electroSurchargeTotal) || 0,
      },

      service: false
    };

  }

  static _calcPleatedPrice(formDataObject, templateName) {

    const PAGE_INFO = ProductItem._getPageInfosByTemplate(templateName)
    const PRICE_TABLE = PAGE_INFO.priceTable;

    const COUNT_DATA = parseInt(formDataObject.count) > 0 ? parseInt(formDataObject.count) : 1;
    const HEIGHT_DATA = formDataObject.height;
    const REPAIR_HEIGHT = formDataObject.heightRepair;
    const HAS_MAX_HEIGHT = HEIGHT_DATA.includes('_max');
    const HEIGHT_VALUE = parseInt(HEIGHT_DATA.replace('_max', ''));
    const MAX_HEIGHT_DATA = parseInt(formDataObject.heightMax);
    const MAX_HEIGHT_VALUE = HAS_MAX_HEIGHT && (MAX_HEIGHT_DATA > HEIGHT_VALUE) ? MAX_HEIGHT_DATA : HEIGHT_VALUE + 1;

    const WIDTH_DATA = formDataObject.width;
    const HAS_MAX_WIDTH = WIDTH_DATA.includes('_max');
    const WIDTH_VALUE = parseInt(WIDTH_DATA.replace('_max', ''));
    const MAX_WIDTH_DATA = parseInt(formDataObject.widthMax);
    const MAX_WIDTH_VALUE = HAS_MAX_WIDTH && (MAX_WIDTH_DATA > WIDTH_VALUE) ? MAX_WIDTH_DATA : WIDTH_VALUE + 1;

    const SERVICE = formDataObject.service ?? false

    const HAS_ELECTRO = !!formDataObject.electro;

    const SURCHARGE_ELECTRO_PERCENT = PAGE_INFO.surchargeElectroPercent;
    let electroSurchargeTotal = 0;

    const HAS_DUET = !!formDataObject.duet;
    const SURCHARGE_DUET_PERCENT = PAGE_INFO.surchargeDuetPercent;
    let duetSurchargeTotal = 0;

    const HAS_MOLD = !!formDataObject.mold;
    const SURCHARGE_MOLD_PERCENT = PAGE_INFO.surchargeMoldPercent;
    let moldSurchargeTotal = 0;

    const HAS_DUAL_FABRIC = !!formDataObject.dualFabric;
    const SURCHARGE_DUAL_FABRIC_PERCENT = PAGE_INFO.surchargeDualFabricPercent;
    let dualFabricSurchargeTotal = 0;

    const HAS_PLAFOND = !!formDataObject.plafond;
    const SURCHARGE_PLAFOND_PERCENT = PAGE_INFO.surchargePlafondPercent;
    let plafondSurchargeTotal = 0;

    const REPAIR_AND_CLEAN_SURCHARGE = PAGE_INFO.repairAndCleanSurchargeValue;
    const REPAIR_ONLY_SURCHARGE = PAGE_INFO.repairSurchargeValue;
    let repairMainSurchargeTotal = 0;

    const REPAIR_EXTRA_WIDTH_SURCHARGE = PAGE_INFO.repairExtraWidthSurchargeValue;
    const REPAIR_DUAL_FABRIC_SURCHARGE = PAGE_INFO.repairDualFabricSurchargeValue;

    let hasRepairExtraWidth = false;
    let repairExtraWidthSurchargeValue = 0;

    let hasRepairDualFabric = false;
    let repairDualFabricSurchargeValue = 0;

    const REPAIR_INFO = formDataObject.repairInfo;
    const HAS_TENSION_SHOES = formDataObject.tensionShoes === 'true';

    let calcHeight = HEIGHT_VALUE;
    let realHeight = HAS_MAX_HEIGHT ? parseInt(MAX_HEIGHT_VALUE) : parseInt(HEIGHT_VALUE);

    if (SERVICE !== 'cleaning') {
      calcHeight = Math.ceil(REPAIR_HEIGHT / 10);
      realHeight = REPAIR_HEIGHT / 10;
    }

    const FILTERED_PRICE_TABLE = PRICE_TABLE.filter(row => row.height >= calcHeight);
    const PRICE_ROW = FILTERED_PRICE_TABLE.length > 0 ? FILTERED_PRICE_TABLE[0] : PRICE_TABLE[PRICE_TABLE.length - 1];

    let productPrice = PRICE_ROW[`width_${WIDTH_VALUE}`]
    let mainPrice = productPrice;

    const IS_CLEANING_MAX_HEIGHT = SERVICE === 'cleaning' && PRICE_TABLE[PRICE_TABLE.length - 1].height < realHeight;

    if (HAS_MAX_HEIGHT && IS_CLEANING_MAX_HEIGHT) {
      const HEIGHT_SURCHARGE_DATA = PAGE_INFO.heightSurchargeTable[0] || false;
      const HEIGHT_SURCHARGE_VALUE = HEIGHT_SURCHARGE_DATA ? HEIGHT_SURCHARGE_DATA[`height_${WIDTH_VALUE}`] : 0;

      let calculatedRest = 1
      if (parseFloat(MAX_HEIGHT_VALUE) >= parseFloat(HEIGHT_VALUE)) {
        calculatedRest = Math.ceil(MAX_HEIGHT_VALUE - parseFloat(HEIGHT_VALUE));
      }

      const HEIGHT_SURCHARGE_QUANTITY = Math.ceil(calculatedRest / 50);
      const HEIGHT_SURCHARGE_TOTAL = HEIGHT_SURCHARGE_QUANTITY * HEIGHT_SURCHARGE_VALUE;

      mainPrice += HEIGHT_SURCHARGE_TOTAL;
      productPrice += HEIGHT_SURCHARGE_TOTAL;
    }

    if (HAS_MAX_WIDTH) {
      const WIDTH_SURCHARGE_DATA = PAGE_INFO.widthSurchargeTable[0] || false;
      const WIDTH_SURCHARGE_VALUE = WIDTH_SURCHARGE_DATA ? WIDTH_SURCHARGE_DATA[`width_${HEIGHT_VALUE}`] : 0;

      let calculatedRest = 1
      if (parseFloat(MAX_WIDTH_VALUE) >= parseFloat(WIDTH_VALUE)) {
        calculatedRest = Math.ceil(MAX_WIDTH_VALUE - parseFloat(WIDTH_VALUE));
      }

      const WIDTH_SURCHARGE_QUANTITY = Math.ceil(calculatedRest / 50);
      const WIDTH_SURCHARGE_TOTAL = WIDTH_SURCHARGE_QUANTITY * WIDTH_SURCHARGE_VALUE;

      mainPrice += WIDTH_SURCHARGE_TOTAL;
      productPrice += WIDTH_SURCHARGE_TOTAL;
    }

    if (SERVICE !== 'repair') {
      if (HAS_ELECTRO) {
        electroSurchargeTotal = (parseFloat(SURCHARGE_ELECTRO_PERCENT) * productPrice) / 100;
        mainPrice += electroSurchargeTotal;
      }

      if (HAS_DUET) {
        duetSurchargeTotal = (parseFloat(SURCHARGE_DUET_PERCENT) * productPrice) / 100;
        mainPrice += duetSurchargeTotal;
      }

      if (HAS_MOLD) {
        moldSurchargeTotal = (parseFloat(SURCHARGE_MOLD_PERCENT) * productPrice) / 100;
        mainPrice += moldSurchargeTotal;
      }

      if (HAS_DUAL_FABRIC) {
        dualFabricSurchargeTotal = (parseFloat(SURCHARGE_DUAL_FABRIC_PERCENT) * productPrice) / 100;
        mainPrice += dualFabricSurchargeTotal;
      }

      if (HAS_PLAFOND && SERVICE !== 'both') {
        plafondSurchargeTotal = (parseFloat(SURCHARGE_PLAFOND_PERCENT) * productPrice) / 100;
        mainPrice += plafondSurchargeTotal;
      }
    }

    if (SERVICE !== 'cleaning') {
      const REPAIR_MAIN_SURCHARGE = SERVICE === 'both' ? parseFloat(REPAIR_AND_CLEAN_SURCHARGE) : parseFloat(REPAIR_ONLY_SURCHARGE);

      if (SERVICE === 'both') repairMainSurchargeTotal += REPAIR_MAIN_SURCHARGE;
      if (SERVICE === 'repair') mainPrice = REPAIR_MAIN_SURCHARGE;

      if (WIDTH_VALUE > 110) {
        hasRepairExtraWidth = true;
        repairExtraWidthSurchargeValue = parseInt(REPAIR_EXTRA_WIDTH_SURCHARGE);
        repairMainSurchargeTotal += repairExtraWidthSurchargeValue;
      }

      if (HAS_DUAL_FABRIC) {
        hasRepairDualFabric = true;
        repairDualFabricSurchargeValue = parseInt(REPAIR_DUAL_FABRIC_SURCHARGE);
        repairMainSurchargeTotal += repairDualFabricSurchargeValue;
      }
    }

    mainPrice += repairMainSurchargeTotal;

    const PRICE_TOTAL = mainPrice * COUNT_DATA;

    const HEIGHT_UNIT = SERVICE === 'cleaning' ? 'cm' : 'mm';

    let currentHeight = HAS_MAX_HEIGHT ? MAX_HEIGHT_VALUE : HEIGHT_VALUE;
    let heightString = HAS_MAX_HEIGHT ? `${currentHeight} ${HEIGHT_UNIT}` : `bis ${currentHeight} ${HEIGHT_UNIT}`;
    if (SERVICE !== 'cleaning') {
      currentHeight = REPAIR_HEIGHT;
      heightString = `${currentHeight} ${HEIGHT_UNIT}`
    }

    return {
      quantity: COUNT_DATA,

      priceArticle: productPrice,
      priceTotal: PRICE_TOTAL,

      productHeight: {
        unit: SERVICE === HEIGHT_UNIT,
        value: currentHeight,
        text: heightString
      },

      productWidth: {
        unit: 'cm',
        value: HAS_MAX_WIDTH ? MAX_WIDTH_VALUE : WIDTH_VALUE,
        text: HAS_MAX_WIDTH ? `${MAX_WIDTH_VALUE} cm` : `bis ${WIDTH_VALUE} cm`
      },

      hasMaxHeight: HAS_MAX_HEIGHT,
      maxHeightValue: MAX_HEIGHT_VALUE,

      hasMaxWidth: HAS_MAX_WIDTH,
      maxWidthValue: MAX_WIDTH_VALUE,

      hasStrips: false,
      strips: {
        percentValue: 0,
        surchargeTotal: 0
      },

      hasElectro: HAS_ELECTRO,
      electro: {
        percentValue: SURCHARGE_ELECTRO_PERCENT,
        surchargeTotal: parseFloat(electroSurchargeTotal) || 0,
      },

      hasDuet: HAS_DUET,
      duet: {
        percentValue: SURCHARGE_DUET_PERCENT,
        surchargeTotal: parseFloat(duetSurchargeTotal) || 0,
      },

      hasMold: HAS_MOLD,
      mold: {
        percentValue: SURCHARGE_MOLD_PERCENT,
        surchargeTotal: parseFloat(moldSurchargeTotal) || 0,
      },

      hasDualFabric: HAS_DUAL_FABRIC,
      dualFabric: {
        percentValue: SURCHARGE_DUAL_FABRIC_PERCENT,
        surchargeTotal: parseFloat(dualFabricSurchargeTotal) || 0,
      },

      hasPlafond: HAS_PLAFOND,
      plafond: {
        percentValue: SURCHARGE_PLAFOND_PERCENT,
        surchargeTotal: parseFloat(plafondSurchargeTotal) || 0,
      },

      repairInfo: REPAIR_INFO,
      tensionShoes: HAS_TENSION_SHOES,

      hasRepairExtraWidth: hasRepairExtraWidth,
      repairExtraWidthSurchargePrice: repairExtraWidthSurchargeValue,

      hasRepairDualFabric: hasRepairDualFabric,
      repairDualFabricSurchargePrice: repairDualFabricSurchargeValue,

      service: SERVICE
    };
  }

  static _calcBalconyCoveringPrice(formDataObject, templateName) {

    const PAGE_INFO = ProductItem._getPageInfosByTemplate(templateName)
    const SQUARE_METER_PRICE = PAGE_INFO.squareMeterPrice;

    const COUNT_DATA = parseInt(formDataObject.count) > 0 ? parseInt(formDataObject.count) : 1;
    const HEIGHT_DATA = parseInt(formDataObject.height) > 0 ? parseInt(formDataObject.height) : 1;
    const WIDTH_DATA = parseInt(formDataObject.width) > 0 ? parseInt(formDataObject.width) : 1;

    const HEIGHT_METER = HEIGHT_DATA / 100;
    const WIDTH_METER = WIDTH_DATA / 100;

    const SQUARE_METER = HEIGHT_METER * WIDTH_METER;
    const MAIN_PRICE = SQUARE_METER * SQUARE_METER_PRICE;
    const PRICE_TOTAL = MAIN_PRICE * COUNT_DATA;

    return {
      quantity: COUNT_DATA,
      productHeight: {
        unit: 'cm',
        value: HEIGHT_DATA,
        text: `${HEIGHT_DATA} cm`
      },

      productWidth: {
        unit: 'cm',
        value: WIDTH_DATA,
        text: `${WIDTH_DATA} cm`
      },

      priceArticle: MAIN_PRICE,
      priceTotal: PRICE_TOTAL,

      hasMaxHeight: false,
      maxHeightValue: false,

      hasMaxWidth: false,
      maxWidthValue: false,
    };
  }

  static _calcVerticalSlatPrice(formDataObject, templateName) {
    const PAGE_INFO = ProductItem._getPageInfosByTemplate(templateName)
    const PRICE_TABLE = PAGE_INFO.priceTable;

    const COUNT_DATA = parseInt(formDataObject.count) > 0 ? parseInt(formDataObject.count) : 1;

    const HEIGHT_DATA = formDataObject.height;
    const HAS_MAX_HEIGHT = HEIGHT_DATA.includes('_max');
    const HEIGHT_VALUE = parseInt(HEIGHT_DATA.replace('_max', ''));
    const MAX_HEIGHT_DATA = parseInt(formDataObject.heightMax);
    const MAX_HEIGHT_VALUE = HAS_MAX_HEIGHT && (MAX_HEIGHT_DATA > HEIGHT_VALUE) ? MAX_HEIGHT_DATA : HEIGHT_VALUE + 1;

    const WIDTH_DATA = formDataObject.width;
    const WIDTH_NAME = WIDTH_DATA.replace('vertical_slat_', '');

    const HAS_STRIPS = !!formDataObject.strips;
    const SURCHARGE_STRIPS_PERCENT = PAGE_INFO.surchargeStripsPercent;
    let stripsSurchargeTotal = 0;

    const HAS_ELECTRO = !!formDataObject.electro;
    const SURCHARGE_ELECTRO_PERCENT = PAGE_INFO.surchargeElectroPercent;
    let electroSurchargeTotal = 0;

    const PRICE_ROW = PRICE_TABLE.find(row => `${row.height}` === `${HEIGHT_VALUE}`);

    let mainPrice = PRICE_ROW[`${WIDTH_NAME}`];
    let productPrice = mainPrice;

    if (HAS_MAX_HEIGHT) {
      const HEIGHT_SURCHARGE_DATA = PAGE_INFO.heightSurchargeValue;
      const HEIGHT_SURCHARGE_VALUE = HEIGHT_SURCHARGE_DATA ? parseInt(HEIGHT_SURCHARGE_DATA) : 0;

      let calculatedRest = 1
      if (parseFloat(MAX_HEIGHT_VALUE) >= parseFloat(HEIGHT_VALUE)) {
        calculatedRest = Math.ceil(MAX_HEIGHT_VALUE - parseFloat(HEIGHT_VALUE));
      }

      const HEIGHT_SURCHARGE_QUANTITY = Math.ceil(calculatedRest / 50);
      const HEIGHT_SURCHARGE_TOTAL = HEIGHT_SURCHARGE_QUANTITY * HEIGHT_SURCHARGE_VALUE;

      mainPrice += HEIGHT_SURCHARGE_TOTAL;
      productPrice += HEIGHT_SURCHARGE_TOTAL;
    }

    if (HAS_STRIPS) {
      stripsSurchargeTotal = (parseFloat(SURCHARGE_STRIPS_PERCENT) * productPrice) * 0.01;
      mainPrice += stripsSurchargeTotal;
    }

    if (HAS_ELECTRO) {
      electroSurchargeTotal = (parseFloat(SURCHARGE_ELECTRO_PERCENT) * productPrice) * 0.01;
      mainPrice += electroSurchargeTotal;
    }

    const PRICE_TOTAL = mainPrice * COUNT_DATA;

    let widthString = 'bis 127 mm';
    if (WIDTH_NAME === 'width_250') widthString = '250 mm'
    else if (WIDTH_NAME === 'wave') widthString = 'Wave-Lamelle'


    return {
      quantity: COUNT_DATA,
      productWidth: {
        unit: 'mm',
        value: widthString,
        text: `${widthString}`
      },

      productHeight: {
        unit: 'cm',
        value: HAS_MAX_HEIGHT ? MAX_HEIGHT_VALUE : HEIGHT_VALUE,
        text: HAS_MAX_HEIGHT ? `${MAX_HEIGHT_VALUE} cm` : `bis ${HEIGHT_VALUE} cm`
      },

      priceArticle: productPrice,
      priceTotal: PRICE_TOTAL,

      hasMaxHeight: HAS_MAX_HEIGHT,
      maxHeightValue: MAX_HEIGHT_VALUE,

      hasMaxWidth: false,
      maxWidthValue: false,

      hasStrips: HAS_STRIPS,
      strips: {
        percentValue: SURCHARGE_STRIPS_PERCENT,
        surchargeTotal: parseFloat(stripsSurchargeTotal) || 0,
      },

      hasElectro: HAS_ELECTRO,
      electro: {
        percentValue: SURCHARGE_ELECTRO_PERCENT,
        surchargeTotal: parseFloat(electroSurchargeTotal) || 0,
      },

      hasDuet: false,
      duet: {
        percentValue: 0,
        surchargeTotal: 0,
      },

      hasMold: false,
      mold: {
        percentValue: 0,
        surchargeTotal: 0,
      },

      hasDualFabric: false,
      dualFabric: {
        percentValue: 0,
        surchargeTotal: 0,
      },

      hasPlafond: false,
      plafond: {
        percentValue: 0,
        surchargeTotal: 0,
      },

      service: false
    };
  }

  static getProductPrice(templateName, formDataObject) {
    const METHODS = {
      'order-product-balcony-covering': () => ProductItem._calcBalconyCoveringPrice(formDataObject, templateName),
      'order-product-louvre': () => ProductItem._calcProductPrice(formDataObject, templateName),
      'order-product-panel-curtain': () => ProductItem._calcProductPrice(formDataObject, templateName),
      'order-product-pleated': () => ProductItem._calcPleatedPrice(formDataObject, templateName),
      'order-product-roll-curtain': () => ProductItem._calcProductPrice(formDataObject, templateName),
      'order-product-vertical-slat': () => ProductItem._calcVerticalSlatPrice(formDataObject, templateName)
    }

    return METHODS[`${templateName}`]();
  }

  calcProductPriceData(templateName, formDataObject) {
    return ProductItem.getProductPrice(templateName, formDataObject);
  }

  getHtmlTemplate(readonly = false) {
    const FORM_DATA = this.formDataObject;
    const PRICE_DATA = this.priceData;

    const TEMPLATE_HELPER = document.createElement('template');
    const CURRENT_HTML_ELEMENT = document.querySelector(`.templates [data-cart-product="${this.pageInfos.productId}"]`)
    const CLONED_NODE = CURRENT_HTML_ELEMENT.cloneNode(true);

    TEMPLATE_HELPER.appendChild(CLONED_NODE);

    const ITEM_TEMPLATE = TEMPLATE_HELPER.firstElementChild;

    ITEM_TEMPLATE.setAttribute('data-uuid', this.uuid);

    let countText = `${FORM_DATA.count}&nbsp;Stk`;

    if (this.priceData.service) {
      const SERVICE_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="service"]');
      let serviceString = 'Reinigung';
      if (this.priceData.service === 'repair') serviceString = 'Reparatur';
      if (this.priceData.service === 'both') serviceString = 'Reinigung & Reparatur';

      SERVICE_ELEMENT.classList.remove('d-none');
      this.#updateElementText(SERVICE_ELEMENT, '[data-info="service-value"]', serviceString);
    }

    const REPAIR_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="repair"]');
    const ADDITIONAL_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="additional"]');
    if (this.priceData.service === 'repair' || this.priceData.service === 'both') {

      const REPAIR_WIDTH_SURCHARGE_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="repair-width-surcharge"]');
      if (REPAIR_WIDTH_SURCHARGE_ELEMENT && this.priceData.hasRepairExtraWidth && this.priceData.repairExtraWidthSurchargePrice > 0) {
        REPAIR_ELEMENT.classList.remove('d-none');
        REPAIR_WIDTH_SURCHARGE_ELEMENT.classList.remove('d-none');

        const REPAIR_WIDTH_SURCHARGE_PRICE = this.priceData.repairExtraWidthSurchargePrice;
        const REPAIR_WIDTH_SURCHARGE_PRICE_TOTAL = parseInt(REPAIR_WIDTH_SURCHARGE_PRICE) * parseInt(FORM_DATA.count);
        this.#updateElementText(REPAIR_WIDTH_SURCHARGE_ELEMENT, '[data-info="repair-width-surcharge-value"]', formatNumber(REPAIR_WIDTH_SURCHARGE_PRICE_TOTAL));
      }

      const REPAIR_DUAL_FABRIC_SURCHARGE_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="repair-dual-fabric-surcharge"]');
      if (REPAIR_DUAL_FABRIC_SURCHARGE_ELEMENT && this.priceData.hasRepairDualFabric && this.priceData.repairDualFabricSurchargePrice > 0) {
        REPAIR_ELEMENT.classList.remove('d-none');
        REPAIR_DUAL_FABRIC_SURCHARGE_ELEMENT.classList.remove('d-none');

        const REPAIR_DUAL_FABRIC_SURCHARGE_PRICE = this.priceData.repairDualFabricSurchargePrice;
        const REPAIR_DUAL_FABRIC_SURCHARGE_PRICE_TOTAL = parseInt(REPAIR_DUAL_FABRIC_SURCHARGE_PRICE) * parseInt(FORM_DATA.count);
        this.#updateElementText(REPAIR_DUAL_FABRIC_SURCHARGE_ELEMENT, '[data-info="repair-dual-fabric-surcharge-value"]', formatNumber(REPAIR_DUAL_FABRIC_SURCHARGE_PRICE_TOTAL));
      }


      const REPAIR_INFO = this.priceData.repairInfo;
      const INFO_STRING = {
        'below_5': 'unter 5 €',
        'from_5': 'ab 5 €',
        'from_10': 'ab 10 €',
        'from_15': 'ab 15 €'
      }
      let repairInfoString = REPAIR_INFO !== 'false' ? INFO_STRING[REPAIR_INFO] : false;

      const REPAIR_INFO_TEXT_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="repair-info"]');
      if (REPAIR_INFO_TEXT_ELEMENT && repairInfoString) {
        ADDITIONAL_ELEMENT.classList.remove('d-none');
        REPAIR_INFO_TEXT_ELEMENT.classList.remove('d-none');
        this.#updateElementText(REPAIR_INFO_TEXT_ELEMENT, '[data-info="repair-info-value"]', repairInfoString)
      }

      const TENSION_SHOES_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="tension-shoes-info"]');
      if (TENSION_SHOES_ELEMENT && this.priceData.tensionShoes) {
        ADDITIONAL_ELEMENT.classList.remove('d-none');
        TENSION_SHOES_ELEMENT.classList.remove('d-none');
        this.#updateElementText(TENSION_SHOES_ELEMENT, '[data-info="tension-shoes-value"]', 'Ja')
      }
    }

    const SPECIALS_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="specials"]');
    if (this.priceData.service !== 'repair') {

      const SPECIAL_STRIPS_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="strips"]');
      if (SPECIAL_STRIPS_ELEMENT && this.priceData.hasStrips && this.priceData.strips.surchargeTotal > 0) {
        SPECIALS_ELEMENT.classList.remove('d-none');
        SPECIAL_STRIPS_ELEMENT.classList.remove('d-none');
        const SURCHARGE_STRIPS_PRICE_VALUE = this.priceData.strips.surchargeTotal;
        const SURCHARGE_STRIPS_PRICE_TOTAL = parseInt(SURCHARGE_STRIPS_PRICE_VALUE) * parseInt(FORM_DATA.count);
        this.#updateElementText(SPECIAL_STRIPS_ELEMENT, '[data-info="strips-value"]', formatNumber(SURCHARGE_STRIPS_PRICE_TOTAL));
      }

      const SPECIAL_DOUBLE_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="double"]');
      if (SPECIAL_DOUBLE_ELEMENT && this.priceData.hasDouble && this.priceData.double.surchargeTotal > 0) {
        SPECIALS_ELEMENT.classList.remove('d-none');
        SPECIAL_DOUBLE_ELEMENT.classList.remove('d-none');
        const SURCHARGE_DOUBLE_PRICE_VALUE = this.priceData.double.surchargeTotal;
        const SURCHARGE_DOUBLE_PRICE_TOTAL = parseInt(SURCHARGE_DOUBLE_PRICE_VALUE) * parseInt(FORM_DATA.count);
        this.#updateElementText(SPECIAL_DOUBLE_ELEMENT, '[data-info="double-value"]', formatNumber(SURCHARGE_DOUBLE_PRICE_TOTAL));
      }


      const SPECIAL_LUXAFLEX_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="luxaflex"]');
      if (SPECIAL_LUXAFLEX_ELEMENT && this.priceData.hasLuxaflex && this.priceData.luxaflex.surchargeTotal > 0) {
        SPECIALS_ELEMENT.classList.remove('d-none');
        SPECIAL_LUXAFLEX_ELEMENT.classList.remove('d-none');
        const SURCHARGE_LUXAFLEX_PRICE_VALUE = this.priceData.luxaflex.surchargeTotal;
        const SURCHARGE_LUXAFLEX_PRICE_TOTAL = parseInt(SURCHARGE_LUXAFLEX_PRICE_VALUE) * parseInt(FORM_DATA.count);
        this.#updateElementText(SPECIAL_LUXAFLEX_ELEMENT, '[data-info="luxaflex-value"]', formatNumber(SURCHARGE_LUXAFLEX_PRICE_TOTAL));
      }

      const SPECIAL_DUAL_FABRIC_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="dual-fabric"]');
      if (SPECIAL_DUAL_FABRIC_ELEMENT && this.priceData.hasDualFabric && this.priceData.dualFabric.surchargeTotal > 0) {
        SPECIALS_ELEMENT.classList.remove('d-none');
        SPECIAL_DUAL_FABRIC_ELEMENT.classList.remove('d-none');
        const SURCHARGE_DUAL_FABRIC_PRICE_VALUE = this.priceData.dualFabric.surchargeTotal;
        const SURCHARGE_DUAL_FABRIC_PRICE_TOTAL = parseInt(SURCHARGE_DUAL_FABRIC_PRICE_VALUE) * parseInt(FORM_DATA.count);
        this.#updateElementText(SPECIAL_DUAL_FABRIC_ELEMENT, '[data-info="dual-fabric-value"]', formatNumber(SURCHARGE_DUAL_FABRIC_PRICE_TOTAL));
      }

      const SPECIAL_DUET_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="duet"]');
      if (SPECIAL_DUET_ELEMENT && this.priceData.hasDuet && this.priceData.duet.surchargeTotal > 0) {
        SPECIALS_ELEMENT.classList.remove('d-none');
        SPECIAL_DUET_ELEMENT.classList.remove('d-none');
        const SURCHARGE_DUET_PRICE_VALUE = this.priceData.duet.surchargeTotal;
        const SURCHARGE_DUET_PRICE_TOTAL = parseInt(SURCHARGE_DUET_PRICE_VALUE) * parseInt(FORM_DATA.count);
        this.#updateElementText(SPECIAL_DUET_ELEMENT, '[data-info="duet-value"]', formatNumber(SURCHARGE_DUET_PRICE_TOTAL));
      }

      const SPECIAL_MOLD_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="mold"]');
      if (SPECIAL_MOLD_ELEMENT && this.priceData.hasMold && this.priceData.mold.surchargeTotal > 0) {
        SPECIALS_ELEMENT.classList.remove('d-none');
        SPECIAL_MOLD_ELEMENT.classList.remove('d-none');
        const SURCHARGE_MOLD_PRICE_VALUE = this.priceData.mold.surchargeTotal;
        const SURCHARGE_MOLD_PRICE_TOTAL = parseInt(SURCHARGE_MOLD_PRICE_VALUE) * parseInt(FORM_DATA.count);
        this.#updateElementText(SPECIAL_MOLD_ELEMENT, '[data-info="mold-value"]', formatNumber(SURCHARGE_MOLD_PRICE_TOTAL));
      }

      const SPECIAL_PLAFOND_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="plafond"]');
      if (SPECIAL_PLAFOND_ELEMENT && this.priceData.hasPlafond && this.priceData.plafond.surchargeTotal > 0) {
        SPECIALS_ELEMENT.classList.remove('d-none');
        SPECIAL_PLAFOND_ELEMENT.classList.remove('d-none');
        const SURCHARGE_PLAFOND_PRICE_VALUE = this.priceData.plafond.surchargeTotal;
        const SURCHARGE_PLAFOND_PRICE_TOTAL = parseInt(SURCHARGE_PLAFOND_PRICE_VALUE) * parseInt(FORM_DATA.count);
        this.#updateElementText(SPECIAL_PLAFOND_ELEMENT, '[data-info="plafond-value"]', formatNumber(SURCHARGE_PLAFOND_PRICE_TOTAL));
      }

      const SPECIAL_ELECTRO_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="electro"]');
      if (SPECIAL_ELECTRO_ELEMENT && this.priceData.hasElectro && this.priceData.electro.surchargeTotal > 0) {
        SPECIALS_ELEMENT.classList.remove('d-none');
        SPECIAL_ELECTRO_ELEMENT.classList.remove('d-none');
        const SURCHARGE_ELECTRO_PRICE_VALUE = this.priceData.electro.surchargeTotal;
        const SURCHARGE_ELECTRO_PRICE_TOTAL = parseInt(SURCHARGE_ELECTRO_PRICE_VALUE) * parseInt(FORM_DATA.count);
        this.#updateElementText(SPECIAL_ELECTRO_ELEMENT, '[data-info="electro-value"]', formatNumber(SURCHARGE_ELECTRO_PRICE_TOTAL));
      }
    }

    this.#updateElementText(ITEM_TEMPLATE, '[data-info="count-value"]', countText);
    this.#updateElementText(ITEM_TEMPLATE, '[data-info="height-value"]', PRICE_DATA.productHeight.text);
    this.#updateElementText(ITEM_TEMPLATE, '[data-info="width-value"]', PRICE_DATA.productWidth.text);
    this.#updateElementText(ITEM_TEMPLATE, '[data-info="price-value"]', formatNumber(this.priceData.priceTotal));

    if (readonly) this.#removeButtons(ITEM_TEMPLATE);
    else this.#attachButtonHandlers(ITEM_TEMPLATE);

    return ITEM_TEMPLATE;
  }

  #updateElementText(snippet, selector, text) {
    const ELEMENT = snippet.querySelector(selector);
    if (ELEMENT) ELEMENT.innerHTML = text;
  }

  #removeButtons(snippet) {
    const EDIT_BUTTON = snippet.querySelector('[data-button="edit-product"]');
    const DELETE_BUTTON = snippet.querySelector('[data-button="delete-product"]');

    EDIT_BUTTON.remove();
    DELETE_BUTTON.remove();
  }

  #attachButtonHandlers(snippet) {
    const EDIT_BUTTON = snippet.querySelector('[data-button="edit-product"]');
    if (EDIT_BUTTON) EDIT_BUTTON.addEventListener('click', () => {
      this.configSection.setConfigPrice(this.priceData.priceTotal);
      this.configSection.element.setAttribute('data-uuid', this.uuid);
      this.configSection.activateEditButton();
      this.configSection.showSection(this.formDataObject);
    });

    const DELETE_BUTTON = snippet.querySelector('[data-button="delete-product"]');
    if (DELETE_BUTTON) DELETE_BUTTON.addEventListener('click', () => {

      const event = new CustomEvent('delete-cart-item', {});
      document.dispatchEvent(event);

      Order.removeProductAndUpdateOrder(this);
      CartSection.updateCart();

      if (Order.products.length <= 0) {
        CartSection.showSectionById('product-select');
        Order.removeShippingInfoAndUpdateOrder();
        Overview.resetToStart();
        NavCartButton.deactivate();
      }

      snippet.remove();
    });
  }
}

export class ProductSelectItem {
  constructor(element, allSelectItemElements = []) {
    this.element = element;
    this.id = element.getAttribute('data-product-id');
    this.siblingElements = Array.from(allSelectItemElements).filter(itemElement => {
      const ITERATION_ELEMENT_ID = itemElement.getAttribute('data-product-id');
      const CURRENT_ELEMENT_ID = this.element.getAttribute('data-product-id');
      return ITERATION_ELEMENT_ID !== CURRENT_ELEMENT_ID;
    })

    this.element.addEventListener('click', () => this.activateSection());
  }

  activateSection() {
    this.siblingElements.forEach(siblingElement => siblingElement.setAttribute('data-active', 'false'));
    this.element.setAttribute('data-active', 'true');
  }
}
